/* eslint-disable max-len */
// External Libraries
import React from 'react';

// Internal modules
import { logger } from '@/lib/logger';
import { once } from '@/lib/utils';
import { IllustrationContainer } from './styles';

export const PayIn4Illustration = (
  props: Partial<React.SVGProps<SVGSVGElement>>,
): JSX.Element => {
  // The oval with the PayPal logo inside looks like a button
  // so we're curious to see how many people click on it
  const logPillIllustrationClickEvent = once(() => {
    logger.info('pay_in_4_illustration_pill_clicked');
  });

  return (
    <IllustrationContainer data-testid="pay-in-4-illustration">
      <svg
        fill="none"
        height={36}
        width={328}
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g filter="url(#prefix__filter0_d)">
          <path d="M134 0h36v36h-36z" fill="#fff" />
          <path
            clipRule="evenodd"
            d="M166.966 28A18 18 0 00170 18h-18 13.846a13.849 13.849 0 01-8.547 12.792A13.846 13.846 0 11152 4.154V0a18 18 0 1014.966 28z"
            fill="#EAECED"
            fillRule="evenodd"
          />
          <path
            d="M152 0a17.998 17.998 0 0118 18h-4.14a13.851 13.851 0 00-4.059-9.8A13.868 13.868 0 00152 4.14V0z"
            fill="#1BD884"
          />
          <path d="M187 0h36v36h-36z" fill="#fff" />
          <path
            clipRule="evenodd"
            d="M219.966 28A18 18 0 00223 18h-18 13.846a13.849 13.849 0 01-8.547 12.792A13.846 13.846 0 11205 4.154V0a18 18 0 1014.966 28z"
            fill="#EAECED"
            fillRule="evenodd"
          />
          <path
            d="M205 0a17.998 17.998 0 0118 18 18.01 18.01 0 01-5.272 12.728A18.005 18.005 0 01205 36v-4.14A13.863 13.863 0 00218.86 18a13.851 13.851 0 00-4.059-9.8A13.868 13.868 0 00205 4.14V0z"
            fill="#1BD884"
          />
          <path d="M240 0h36v36h-36z" fill="#fff" />
          <path
            clipRule="evenodd"
            d="M272.966 28A18 18 0 00276 18h-18 13.846a13.849 13.849 0 01-8.547 12.792A13.846 13.846 0 11258 4.154V0a18 18 0 1014.966 28z"
            fill="#EAECED"
            fillRule="evenodd"
          />
          <path
            d="M258 0a18 18 0 11-18 18h4.14A13.86 13.86 0 10258 4.14V0z"
            fill="#1BD884"
          />
          <path d="M292 0h36v36h-36z" fill="#fff" />
          <path
            clipRule="evenodd"
            d="M324.966 28A18 18 0 00328 18h-18 13.846a13.849 13.849 0 01-8.547 12.792A13.846 13.846 0 11310 4.154V0a18 18 0 1014.966 28z"
            fill="#EAECED"
            fillRule="evenodd"
          />
          <path
            d="M328 18c0 9.941-8.059 18-18 18s-18-8.059-18-18 8.059-18 18-18 18 8.059 18 18zm-31.86 0c0 7.655 6.205 13.86 13.86 13.86 7.655 0 13.86-6.205 13.86-13.86 0-7.655-6.205-13.86-13.86-13.86-7.655 0-13.86 6.205-13.86 13.86z"
            fill="#1BD884"
          />
          <path
            d="M153.661 23.2V12.09h-.781l-3.672 1.547v1.391l2.781-.984V23.2h1.672zM207.021 15.466c0 1.859-2.562 4.218-5.39 6.562V23.2h7.578v-1.438h-5.328c2.531-1.906 4.906-4.375 4.906-6.546 0-1.782-1.266-3.125-3.484-3.125-1.375 0-2.625.562-3.438 1.218v1.61c.828-.719 2.016-1.313 3.172-1.313 1.266 0 1.984.703 1.984 1.86zM254.631 22.606c.765.469 1.75.766 2.953.766 2.375 0 4.5-1.453 4.5-3.703 0-1.813-1.594-2.766-3.266-2.969l2.719-3.125v-1.313h-6.484v1.47h4.609l-2.828 3.374v.531c2.484.016 3.547.72 3.547 2.063 0 1.36-1.219 2.234-2.906 2.234-1.047 0-2.032-.28-2.844-.843v1.515zM311.514 23.2v-2.86h2.437v-1.296h-2.437v-2.719h-1.5v2.719h-3.235c.86-2.125 2.391-4.875 4.203-6.782h-1.922c-1.609 1.75-3.359 4.954-4.031 6.985v1.094h4.985V23.2h1.5z"
            fill="#2C2E2F"
          />
          <path
            d="M98.932 18.45h20.693M114.226 24.177l5.726-5.727-5.726-5.728"
            stroke="#2C2E2F"
            strokeLinecap="round"
            strokeWidth={2}
          />
          <rect
            fill="#FFC43A"
            height={36}
            onClick={logPillIllustrationClickEvent}
            rx={17}
            width={90}
          />
          <path
            clipRule="evenodd"
            d="M55.187 12.588c.259-1.65-.002-2.772-.894-3.79C53.311 7.68 51.537 7.2 49.267 7.2H42.68a.943.943 0 00-.931.796L39.004 25.4a.566.566 0 00.559.654h4.067l-.28 1.78c-.048.301.184.573.488.573h3.428a.825.825 0 00.815-.697l.034-.174.646-4.097.041-.227a.825.825 0 01.815-.696h.513c3.321 0 5.922-1.35 6.682-5.254.317-1.631.153-2.993-.686-3.95a3.262 3.262 0 00-.939-.724z"
            fill="#009CDE"
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M55.187 12.588c.259-1.65-.002-2.772-.894-3.79C53.311 7.68 51.537 7.2 49.267 7.2H42.68a.943.943 0 00-.931.796L39.004 25.4a.566.566 0 00.559.654h4.067l1.022-6.482-.032.204a.94.94 0 01.928-.796h1.933c3.797 0 6.77-1.544 7.639-6.006.025-.132.047-.26.067-.386z"
            fill="#012169"
            fillRule="evenodd"
          />
          <path
            clipRule="evenodd"
            d="M45.75 12.61a.825.825 0 01.814-.697h5.165c.611 0 1.182.04 1.704.124a7.242 7.242 0 01.845.188l.195.061c.256.085.494.185.714.302.259-1.65-.002-2.772-.894-3.79C53.311 7.68 51.537 7.2 49.267 7.2H42.68a.943.943 0 00-.932.796L39.004 25.4a.566.566 0 00.559.654h4.067l1.022-6.482 1.097-6.962z"
            fill="#003087"
            fillRule="evenodd"
          />
        </g>
        <defs>
          <filter
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
            height={36}
            id="prefix__filter0_d"
            width={328}
            x={0}
            y={0}
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset />
            <feColorMatrix values="0 0 0 0 0.717647 0 0 0 0 0.737255 0 0 0 0 0.74902 0 0 0 1 0" />
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend
              in="SourceGraphic"
              in2="effect1_dropShadow"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </IllustrationContainer>
  );
};
